import type { Group } from "@ptx-autonomous/libs/api";

export const userGroupPermissionsSettings: {
	cognitoAllGroups: Group[];
	cognitoAllowedGroups: Group[];
	cognitoAdminGroups: Group[];
	cognitoAccountOwnerGroups: Group[];
	cognitoDealerGroups: Group[];
	allowedGroupsToAddEngineeringUser: Group[];
	allowedGroupsToAddTechSupportUser: Group[];
	allowedGroupsToAddDealerOwnerUser: Group[];
	allowedGroupsToAddDealerUser: Group[];
	allowedGroupsToAddSalesUser: Group[];
	allowedGroupsToAddOrganizationOwnerUser: Group[];
	allowedGroupsToAddOrganizationMemberUser: Group[];
	allowedGroupsToSwitchOrganization: Group[];
	allowedGroupsToSwitchEnvironment: Group[];
	allowedGroupsToSystemSoftware: Group[];
	allowedGroupsToRemoteSupport: Group[];
	allowedGroupsToSoftwareUpdate: Group[];
	allowedGroupsToSystemStream: Group[];
	allowedGroupsToMapTesting: Group[];
	allowedGroupsToManagerEngineeringOrganization: Group[];
	allowedGroupsToViewEngineeringOrganization: Group[];
	allowedGroupsToManagerSubscriptions: Group[];
	allowedGroupsToManagerMachineNotes: Group[];
	allowedGroupsToFoxgloveBridgeControls: Group[];
	allowedGroupsToSystemLogsConnections: Group[];
	allowedGroupsToManagerResourceDocuments: Group[];
	allowedGroupsToEngineeringSupportAgent: Group[];
	allowedGroupsToDealerSupportAgent: Group[];
	allowedGroupsToAddFields: Group[];
	allowedGroupsForInternalImportExportFields: Group[];
	allowedGroupsToDownloadMissionData: Group[];
	allowedGroupsToViewInternalIds: Group[];
	allowedGroupsToSeePTxSupportContact: Group[];
	allowedGroupsToSeeVerboseDiagnostics: Group[];
	allowedGroupsToViewAllCameraFeeds: Group[];
	allowedGroupsToViewAssociatedOrganizationCameraFeeds: Group[];
	allowedGroupsToAdminAnalytics: Group[];
	allowedGroupsToAllMachines: Group[];
	allowedGroupsToIncreasedSpeed: Group[];
	allowedGroupsToEvents: Group[];
	allowedGroupsToFeatureFlags: Group[];
	allowedGroupsToAdvancedPathPlanningOptions: Group[];
	allowedGroupsToSwitchOrganizationOnly: Group[];
	allowedGroupsToUseVirtualGamepad: Group[];
	allowedGroupsToUseCloudGamepadControls: Group[];
	allowedGroupsToUseUnloadTargetPresets: Group[];
	allowedGroupsToUseNonRtkRecordedBoundaries: Group[];
	allowedGroupsToUseTillageImplementTurns: Group[];
	allowedGroupsToTransferMachine: Group[];
	allowedGroupsToAdminDashboard: Group[];
	allowedGroupsToViewSimulators: Group[];
	allowedGroupsToViewPlannedPaths: Group[];
} = {
	cognitoAllGroups: [
		"FlightPathAdmin",
		"AccountOwner",
		"Manager",
		"Operator",
		"TechSupport",
		"Sales",
		"Engineering",
		"DealerUser",
		"DealerOwner",
	],
	cognitoAllowedGroups: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"Sales",
		"DealerOwner",
		"DealerUser",
	], // Manager and AccountOwner are not allowed to get access into the admin app for now
	cognitoAdminGroups: ["FlightPathAdmin"],
	cognitoAccountOwnerGroups: ["Manager", "AccountOwner"],
	cognitoDealerGroups: ["DealerUser", "DealerOwner"],
	allowedGroupsToAddEngineeringUser: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToAddTechSupportUser: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
	],
	allowedGroupsToAddDealerOwnerUser: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"Sales",
	],
	allowedGroupsToAddDealerUser: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"Sales",
		"DealerOwner",
	],
	allowedGroupsToAddSalesUser: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"Sales",
	],
	allowedGroupsToAddOrganizationOwnerUser: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
	],
	allowedGroupsToAddOrganizationMemberUser: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
		"AccountOwner",
		"Manager",
	],
	allowedGroupsToSwitchOrganization: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"Sales",
		"DealerOwner",
		"DealerUser",
	],
	allowedGroupsToSwitchEnvironment: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
	],
	allowedGroupsToSeeVerboseDiagnostics: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"Sales",
	],
	allowedGroupsToViewAllCameraFeeds: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"Sales",
	],
	allowedGroupsToViewAssociatedOrganizationCameraFeeds: [
		"DealerOwner",
		"DealerUser",
	],
	allowedGroupsToRemoteSupport: ["Engineering", "TechSupport"],
	allowedGroupsToSystemSoftware: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
		"AccountOwner",
		"Manager",
		"Operator",
	],
	allowedGroupsToSoftwareUpdate: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
		"AccountOwner",
		"Manager",
		"Operator",
	],
	allowedGroupsToSystemStream: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
	],
	allowedGroupsToMapTesting: ["FlightPathAdmin", "Engineering", "Sales"],
	allowedGroupsToManagerEngineeringOrganization: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
	],
	allowedGroupsToViewEngineeringOrganization: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
	],
	allowedGroupsToManagerSubscriptions: [
		"TechSupport",
		"Sales",
		"DealerOwner",
		"DealerUser",
	],
	allowedGroupsToManagerMachineNotes: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
	],
	allowedGroupsToFoxgloveBridgeControls: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToSystemLogsConnections: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
	],
	allowedGroupsToManagerResourceDocuments: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
	],
	allowedGroupsToEngineeringSupportAgent: [
		"FlightPathAdmin",
		"Admin",
		"Engineering",
	],
	allowedGroupsToDealerSupportAgent: [
		"TechSupport",
		"Sales",
		"DealerOwner",
		"DealerUser",
	],
	allowedGroupsToAddFields: ["FlightPathAdmin", "Engineering"],
	allowedGroupsForInternalImportExportFields: [
		"FlightPathAdmin",
		"Engineering",
	],
	allowedGroupsToDownloadMissionData: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToViewInternalIds: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToSeePTxSupportContact: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
		"Sales",
	],
	allowedGroupsToAdminAnalytics: [
		"FlightPathAdmin",
		"Engineering",
		"Sales",
		"DealerOwner",
		"DealerUser",
		"TechSupport",
	],
	allowedGroupsToAllMachines: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
	],
	allowedGroupsToIncreasedSpeed: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToEvents: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToFeatureFlags: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToAdvancedPathPlanningOptions: [
		"FlightPathAdmin",
		"Engineering",
	],
	allowedGroupsToUseVirtualGamepad: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToUseCloudGamepadControls: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToUseUnloadTargetPresets: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToUseNonRtkRecordedBoundaries: [
		"FlightPathAdmin",
		"Engineering",
	],
	allowedGroupsToUseTillageImplementTurns: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToAdminDashboard: [
		"FlightPathAdmin",
		"Engineering",
		"TechSupport",
		"DealerOwner",
		"DealerUser",
	],
	get allowedGroupsToSwitchOrganizationOnly() {
		return this.allowedGroupsToSwitchOrganization.filter(
			group => !this.allowedGroupsToSwitchEnvironment.includes(group),
		);
	},
	allowedGroupsToTransferMachine: [
		"FlightPathAdmin",
		"Engineering",
		//TODO: We will allow the dealer later
	],
	allowedGroupsToViewSimulators: ["FlightPathAdmin", "Engineering"],
	allowedGroupsToViewPlannedPaths: ["FlightPathAdmin", "Engineering"],
};
